<script lang="ts">
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import Radio from '@smui/radio';

	export let radio: number|string;
	export let options: {value:number|string, label:string, katex:boolean}[];
	export let preIntType;

</script>

{#each options as option}
<FormField>
<Radio 
	bind:group={radio}
	value={option.value}
	disabled={(preIntType=="1" && option.value=="3" )? true : false}
/>
	<span slot="label">
		{#if option.katex}
			<Katex math={option.label}/>
		{:else}
			option.label
		{/if}
	</span>
</FormField>
{/each}